import { render, staticRenderFns } from "./memoryTab.vue?vue&type=template&id=bc39b7d8&scoped=true&"
import script from "./memoryTab.vue?vue&type=script&lang=js&"
export * from "./memoryTab.vue?vue&type=script&lang=js&"
import style1 from "./memoryTab.vue?vue&type=style&index=1&id=bc39b7d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc39b7d8",
  null
  
)

export default component.exports